import React from "react";
import { Alert, Box, Button, Group, Loader, MantineProvider, Space, Text } from "@mantine/core";
import { useOs } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { MdWarningAmber } from "react-icons/md";
import { FxIdDomainSettingsWebRuntimeType } from "../../../Api/gen";
import { webPlayerStore } from "../store/webPlayerStore";

const useWebRuntimeType = (): FxIdDomainSettingsWebRuntimeType => {
	const { userAgent } = window.navigator;
	const ipadPlatform = /iPad/i;
	const os = useOs();
	if (os === "undetermined") return FxIdDomainSettingsWebRuntimeType.NUMBER_unknown_default_open_api;
	if (ipadPlatform.test(userAgent)) return FxIdDomainSettingsWebRuntimeType.IPad;
	if (os === "android") return FxIdDomainSettingsWebRuntimeType.Android;
	if (os === "ios") return FxIdDomainSettingsWebRuntimeType.IPhone;
	return FxIdDomainSettingsWebRuntimeType.Desktop;
};

export const OsGuard = (props: { children: React.ReactNode }) => {
	const { t } = useTranslation();
	const gameConfig = webPlayerStore((state) => state.gameConfig);

	const runtimeType = useWebRuntimeType();

	const redirectUrl = gameConfig.PlatformData.Web?.PlayUrl;
	const shouldBlock =
		Boolean(gameConfig.PlatformData.Web?.Runtimes) &&
		!gameConfig.PlatformData.Web?.Runtimes?.Supported.includes(runtimeType);
	if (shouldBlock)
		return (
			<MantineProvider>
				<Container>
					<Alert variant="filled" color="red" icon={<MdWarningAmber size={20} />} maw={400}>
						<Text>
							{t("web_player.platform_unsupported.message", {
								game: t(`seo.${gameConfig.GameSystemName}.name`)
							})}
						</Text>
						<Text></Text>
						{redirectUrl && (
							<Group position="center" mt="sm">
								<Button component="a" href={redirectUrl} color="red" variant="light">
									{t("web_player.platform_unsupported.button")}
								</Button>
								<Space w={20} ml="xs" />
							</Group>
						)}
					</Alert>
				</Container>
			</MantineProvider>
		);
	return <>{props.children}</>;
};

const Container = (props: { children: React.ReactNode }) => (
	<Box sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
		{props.children}
	</Box>
);
